import type { MeResponse } from '../../entities/me/me-contract.types';

/**
 * Расширенная сводка tenant-дашборда (клиенты, тренеры, оплаты, YClients, план).
 * Нужен контекст организации: для СА он приходит из effective `organization_id` в GET `/auth/me`
 * при выбранной студии (query / `X-Impersonate-Organization-Id`), иначе `null` — сводку не показываем.
 */
export function isOrgTenantDashboardOpsAudience(me: MeResponse | null): boolean {
  const oid = me?.organization_id;
  return oid != null && oid > 0;
}
